import { Modal } from 'antd';
import styled from 'styled-components';

// Design tokens from ticket mockup "dense-list.html".
export const StyledModal = styled(Modal)`
  .ant-modal-body {
    padding-top: 4px;
  }
  .ant-modal-header {
    margin-bottom: 12px;
  }
`;

/* ── Header ── */
export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

export const CountBadge = styled.span`
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 30px;
  height: 30px;
  padding: 0 8px;
  border-radius: 8px;
  background: #dc2626;
  color: #fff;
  font-weight: 700;
  font-size: 15px;
  line-height: 1;
`;

export const HeaderText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const HeaderTitle = styled.span`
  font-size: 18px;
  font-weight: 700;
  color: #111827;
  line-height: 1.2;
`;

export const HeaderSub = styled.span`
  font-size: 13px;
  color: #6b7280;
  font-weight: 400;
`;

/* ── Category pills ── */
export const CategoryBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 4px 0 8px;
`;

export const CategoryPill = styled.button<{ $active?: boolean }>`
  padding: 4px 14px;
  border: 1px solid ${({ $active }) => ($active ? '#dc2626' : '#e5e7eb')};
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  color: ${({ $active }) => ($active ? '#b91c1c' : '#4b5563')};
  background: ${({ $active }) => ($active ? '#fef2f2' : '#fff')};
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    border-color: #fca5a5;
    color: #b91c1c;
  }
`;

/* ── Rows ── */
export const ItemRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 0;
  border-top: 1px solid #f0f0f0;
`;

export const IconBox = styled.span`
  flex: 0 0 auto;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #fef2f2;
  color: #dc2626;
  font-size: 16px;
`;

export const ItemMain = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
  flex: 1;
`;

export const ItemTopLine = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const CategoryLabel = styled.span`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.3px;
  color: #b91c1c;
  text-transform: uppercase;
`;

export const StatusTag = styled.span`
  padding: 1px 8px;
  border-radius: 999px;
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
  font-size: 11px;
  font-weight: 600;
`;

export const ItemTitle = styled.span`
  font-weight: 700;
  color: #111827;
  font-size: 14px;
`;

export const ItemMeta = styled.span`
  color: #6b7280;
  font-size: 12px;
`;

export const RowAction = styled.div`
  margin-left: auto;
  flex: 0 0 auto;
`;

/* ── Footer ── */
export const FooterRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const SnoozeText = styled.button`
  background: none;
  border: none;
  color: #6b7280;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  padding: 4px 0;

  &:hover {
    color: #374151;
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;
